import React from "react";
import LoadingLogoSpinner from "../../components/loading-pie/LoadingLogoSpinner";

export const AuthLoadingScreen: React.FC = () => (
    <div className="auth-loading-screen">
        <LoadingLogoSpinner/>
    </div>
);
